import { TextField, InputAdornment, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import PropTypes from 'prop-types';

SnapshotsSearchBar.propTypes = {
  searchString: PropTypes.string,
  setSearchString: PropTypes.func
};

export default function SnapshotsSearchBar({ searchString, setSearchString }) {
  const handleChange = (e) => {
    const val = e.target.value;
    setSearchString(val);
  };

  const handleClear = () => {
    setSearchString('');
  };

  return (
    <TextField
      fullWidth
      size="small"
      value={searchString}
      onChange={handleChange}
      placeholder="Search Snapshots ..."
      variant="outlined"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
        endAdornment: searchString && (
          <InputAdornment position="end">
            <IconButton size="small" onClick={handleClear}>
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        )
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: 2
        }
      }}
    />
  );
}
